import { Component } from '@angular/core';
import { ModalService } from '../../modules/modal/modal.service';

import { Message } from '../../models';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation-modal.component.html',
})
export class ConfirmationModalComponent {
  data: Message;
  success: Function;
  cancel: Function;

  constructor(
    private _modalService: ModalService
  ) {}

  onOkClicked(): void {
    if (this.success) {
      this.success();
    }
    this._modalService.closeModal();
  }

  onCancelClicked(): void {
    if (this.cancel) {
      this.cancel();
    }
    this._modalService.closeModal();
  }
}
